import exportComponentsToRails from "../src/shared/utilities/exportComponentsToRails";

exportComponentsToRails("virtualOpenHouse", {
  joinLink: import("../src/features/virtual-open-house-join-link")
});
